/* MCCI product page, from ug67-layout-preview 8.
   Reads the variant data that sections/mcci-product.liquid writes into
   [data-mcci-pdp-json] and redraws price, P/N, lifecycle, status line,
   alternative callout and buy row on every option change. */
(function(){
  // Fixed labels and notes. Change wording here, never in metafield values.
  var LIFE={active:['Active','p-ok','Current production'],obsolete:['Obsolete','p-mute','Documentation only']};
  var SUPPLY={distributor:['Contact sales','for delivery time'],manufactured:['Build to order','Built by the manufacturer on order'],
    assembled:['Assemble to order','Assembled and kitted by MCCI on order']};
  var DASH='—';

  function esc(s){return String(s==null?'':s).replace(/[&<>"']/g,function(c){
    return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];});}
  function pill(t,c){return '<span class="mcci-pill '+c+'">'+esc(t)+'</span>';}
  function dot(t,c){return '<span class="mcci-dot d-'+c+'" aria-hidden="true"></span><span class="mcci-stat">'+esc(t)+'</span>';}
  function sep0(){return '<span class="mcci-sep">&middot;</span>';}

  function money(cents,fmt){
    fmt=fmt||('$'+'{'+'{amount}}');
    function f(n,d,t,dec){var s=(n/100).toFixed(d).split('.');
      s[0]=s[0].replace(/\B(?=(\d{3})+(?!\d))/g,t);return s[1]?s[0]+dec+s[1]:s[0];}
    var m=fmt.match(/\{\{\s*(\w+)\s*\}\}/), k=m?m[1]:'amount', v;
    if(k==='amount_no_decimals') v=f(cents,0,',','.');
    else if(k==='amount_with_comma_separator') v=f(cents,2,'.',',');
    else if(k==='amount_no_decimals_with_comma_separator') v=f(cents,0,'.',',');
    else v=f(cents,2,',','.');
    var tmp=document.createElement('div');tmp.innerHTML=fmt.replace(/\{\{\s*\w+\s*\}\}/,v);
    return tmp.textContent;
  }

  // Moves the "Technical Resources" / "Technical Documents" heading and
  // everything after it out of the description and below the Read more
  // button, so only the text above it gets clamped.
  function splitDesc(desc,more){
    if(!desc||!more) return;
    var re=/^technical\s+(resources|documents)\s*:?$/i, hit=null;
    var cand=desc.querySelectorAll('h1,h2,h3,h4,h5,h6,p,strong,b');
    for(var i=0;i<cand.length;i++){if(re.test(cand[i].textContent.trim())){hit=cand[i];break;}}
    if(!hit) return;
    var node=hit;
    while(node.parentNode!==desc&&!node.previousElementSibling) node=node.parentNode;
    if(node===desc.firstElementChild&&node.parentNode===desc) return;
    var tail=document.createElement('div');
    tail.className='mcci-desc mcci-desc-tail rte';
    var parent=node.parentNode;
    while(node){var next=node.nextSibling; tail.appendChild(node); node=next;}
    // Anything after the nested block that held the heading moves too.
    while(parent&&parent!==desc){var n=parent.nextSibling;
      while(n){var nx=n.nextSibling; tail.appendChild(n); n=nx;} parent=parent.parentNode;}
    more.parentNode.insertBefore(tail,more.nextSibling);
  }

  function init(root){
    if(!root||root.dataset.ready) return; root.dataset.ready='1';
    var D=JSON.parse(root.querySelector('[data-mcci-pdp-json]').textContent);
    var $=function(s){return root.querySelector(s);};
    var sels=[].slice.call(root.querySelectorAll('select[data-opt-index]'));
    var qty=$('[data-qty]'),qwrap=root.querySelector('.mcci-qty'),qnote=$('[data-qnote]'),cart=$('[data-cart]'),
      sales=$('[data-sales]'),docs=$('[data-docs]'),idInput=$('[data-variant-id]'),
      supply=SUPPLY[D.supply]||SUPPLY.distributor,cur=null;

    function find(){
      if(!sels.length) return D.variants[0];
      for(var i=0;i<D.variants.length;i++){var v=D.variants[i],ok=true;
        for(var j=0;j<sels.length;j++){if(v.options[j]!==sels[j].value){ok=false;break;}}
        if(ok) return v;}
      return null;
    }
    function byId(id){for(var i=0;i<D.variants.length;i++){if(D.variants[i].id===id) return D.variants[i];}return null;}
    function state(v){
      if(v.life==='obsolete') return 'out';
      if(!v.tracked) return 'untracked';
      if(v.qty>D.lowStock) return 'stock';
      if(v.qty>0) return 'low';
      if(v.policy==='continue') return 'back';
      return 'out';
    }
    function altBlock(v){
      if(!v.rb||v.life!=='obsolete') return '';
      var href=v.rb.same?'#':esc(v.rb.url);
      return '<div class="mcci-alt"><b>Recommended Alternative</b>This version is no longer built. For new designs MCCI recommends the <a href="'+href+'" data-rb="'+v.rb.id+'"'+
        (v.rb.same?' data-same="1"':'')+'>'+esc(v.rb.name)+'</a>'+(v.rb.same&&v.rb.opts?' ('+esc(v.rb.opts)+')':'')+(v.rb.sku?', MCCI P/N '+esc(v.rb.sku):'')+'.'+
        (v.reason?'<span class="mcci-reason">'+esc(v.reason)+'</span>':'')+'</div>';
    }
    function checkQty(){
      qnote.className='mcci-qnote'; qnote.textContent='';
      if(!cur||qwrap.hidden||qty.disabled) return;
      var n=parseInt(qty.value,10);
      if(isNaN(n)||n<1){qnote.textContent='Enter a quantity of 1 or more.';qnote.className='mcci-qnote err';return;}
      if(cur.tracked&&cur.qty>0&&n>cur.qty&&cur.policy==='continue'){
        var blt=cur.lead||(D.vendor==='MCCI'?'':D.leadProduct);
        qnote.textContent=cur.qty+' ship now, the remaining '+(n-cur.qty)+(blt?' will be delivered within '+blt+'.':' follow on backorder. Contact sales for the delivery date.');
      }
    }
    function setMedia(id){
      if(!id) return;
      var t=root.querySelector('.mcci-thumb[data-media-id="'+id+'"]');
      if(t) showThumb(t);
    }
    function showThumb(t){
      var main=$('.mcci-main-img'); if(!main) return;
      main.removeAttribute('srcset'); main.src=t.dataset.full;
      var im=t.querySelector('img'); if(im) main.alt=im.alt;
      [].forEach.call(root.querySelectorAll('.mcci-thumb'),function(x){x.classList.remove('on');});
      t.classList.add('on');
    }
    function buttons(mode){
      // mode: buy | soldout | none | obsolete
      // Sold out keeps Shopify's own wording; "Unavailable" is what Shopify
      // shows for an option combination that does not exist.
      // none (no such variant) and obsolete: only Contact sales stays.
      cart.hidden=(mode==='none'||mode==='obsolete'); cart.disabled=(mode!=='buy');
      cart.textContent=(mode==='soldout')?'Sold out':'Add to cart';
      qwrap.hidden=(mode==='none'||mode==='obsolete');
      qty.disabled=(mode!=='buy');
      [].forEach.call(root.querySelectorAll('[data-minus],[data-plus]'),function(b){b.disabled=(mode!=='buy');});
      docs.hidden=true; sales.hidden=false;
    }
    function render(push){
      var v=find(); cur=v;
      var life=$('[data-life]'),status=$('[data-status]'),alt=$('[data-alt]'),
        pn=$('[data-pn]'),vpn=$('[data-vpn]'),vbox=$('[data-vpn-box]'),price=$('[data-price]');
      if(!v){
        pn.textContent=DASH; price.hidden=true; if(vbox) vbox.hidden=true;
        life.innerHTML=DASH; life.title='';
        status.parentNode.hidden=false; status.innerHTML=dot('Not offered','stop')+sep0()+'<span class="mcci-stat-txt">This combination is not built</span>';
        alt.innerHTML=''; buttons('none'); checkQty(); return;
      }
      idInput.value=v.id;
      pn.textContent=v.sku||DASH;
      price.textContent=money(v.price,D.moneyFormat); price.hidden=(v.life==='obsolete');
      if(vbox){vbox.hidden=!v.vpn; vpn.textContent=v.vpn||'';}
      sales.href='mailto:'+D.salesEmail+'?subject='+encodeURIComponent(D.title+' '+(v.sku||''))+
        '&body='+encodeURIComponent('Part number: '+(v.sku||'')+'\nQuantity: '+qty.value+'\n\nQuestion:');

      var L=LIFE[v.life]||LIFE.active; life.innerHTML=pill(L[0],L[1]); life.title=L[2];

      var s=state(v), ship=D.shipText||'Ships in 1-2 days',
        lt=v.lead||(D.vendor==='MCCI'?'':D.leadProduct);
      // One combined line: availability and lead time. Hidden for obsolete variants (the badge already says so).
      status.parentNode.hidden=(v.life==='obsolete');
      var sep='<span class="mcci-sep">&middot;</span>';
      var tail=sep+'<span class="mcci-stat-txt">'+esc(ship)+'</span>';
      if(s==='untracked') status.innerHTML=dot('In stock','ok')+tail;
      else if(s==='stock') status.innerHTML=dot((D.showCount?v.qty+' in stock':'In stock'),'ok')+tail;
      else if(s==='low') status.innerHTML=dot('Low stock'+(D.showCount?': '+v.qty+' left':''),'warn')+tail;
      else if(s==='back') status.innerHTML=
        (D.vendor==='MCCI')
          ? dot('Out of stock','warn')+sep0()+'<span class="mcci-stat-txt">Contact sales for delivery time</span>'
          : (lt?dot('Delivery within '+lt,'acc')
              :(D.supply==='distributor'||!SUPPLY[D.supply]?dot('Contact sales for delivery time','acc')
                 :dot(supply[0]+' – '+supply[1],'acc')));
      else if(v.life==='obsolete') status.innerHTML='';
      else status.innerHTML=dot('Contact sales','acc');

      // MCCI's own products on backorder:.

      if(v.life==='obsolete') buttons('obsolete');
      else if(s==='out') buttons('soldout');
      else buttons('buy');

      alt.innerHTML=altBlock(v);
      setMedia(v.media);
      if(push&&window.history&&history.replaceState){
        var u=new URL(location.href); u.searchParams.set('variant',v.id); history.replaceState({},'',u.toString());
      }
      checkQty();
    }

    sels.forEach(function(s){s.addEventListener('change',function(){render(true);});});
    qty.addEventListener('input',checkQty);
    $('[data-minus]').addEventListener('click',function(){qty.value=Math.max(1,(parseInt(qty.value,10)||1)-1);checkQty();});
    $('[data-plus]').addEventListener('click',function(){qty.value=(parseInt(qty.value,10)||0)+1;checkQty();});
    $('[data-alt]').addEventListener('click',function(e){
      var a=e.target.closest('a[data-same]'); if(!a) return;
      e.preventDefault(); var t=byId(+a.dataset.rb); if(!t) return;
      sels.forEach(function(s,i){s.value=t.options[i];}); render(true);
    });
    $('[data-copy]').addEventListener('click',function(){
      var b=this,txt=$('[data-pn]').textContent;
      var done=function(){b.textContent='Copied';setTimeout(function(){b.textContent='Copy';},1200);};
      if(navigator.clipboard) navigator.clipboard.writeText(txt).then(done,function(){}); });
    var desc=$('[data-desc]'),more=$('[data-more]');
    splitDesc(desc,more);
    if(desc&&more&&desc.scrollHeight>340){
      desc.classList.add('is-clamped'); more.hidden=false;
      more.addEventListener('click',function(){
        var open=desc.classList.toggle('is-clamped')===false;
        more.textContent=open?'Read less':'Read more'; more.setAttribute('aria-expanded',open?'true':'false');
        if(!open){var r=desc.getBoundingClientRect(); if(r.top<0) window.scrollBy(0,r.top-80);}
      });
    }
    [].forEach.call(root.querySelectorAll('.mcci-thumb'),function(t){t.addEventListener('click',function(){showThumb(t);});});
    root.querySelector('.mcci-buy-form').addEventListener('submit',function(e){
      var n=parseInt(qty.value,10); if(!cur||cart.disabled||isNaN(n)||n<1){e.preventDefault();checkQty();}
    });
    render(false);
  }

  function boot(){[].forEach.call(document.querySelectorAll('[data-mcci-pdp]'),init);}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
  document.addEventListener('shopify:section:load',boot);
})();
